import React, { useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import { calendars, getUrlCalendar } from '../../Helpers/CalendarHelpers';

const SchedulePopover = ({ content, schedule, buttonType = 'text', placement = false }) => {
  const target = useRef();
  const [show, setShow] = useState(false);

  const onToggle = (e) => {
    e.stopPropagation();
    setShow(!show);
  };

  const position = placement || buttonType === 'text' ? 'right' : 'left';

  return (
    <>
      {buttonType === 'text' ? (
        <Button className='myList' bsPrefix='' ref={target} onClick={onToggle}>
          <i className='bi bi-plus-lg'></i>
          <span>{schedule}</span>
        </Button>
      ) : (
        <Button
          className='schedule btn-circle'
          bsPrefix=''
          ref={target}
          size='sm'
          onClick={onToggle}
        >
          <svg style={{color: '#dc3545'}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"/>
          </svg>
        </Button>
      )}
      <Overlay
        show={show}
        target={target.current}
        placement={position}
        rootClose
        onHide={() => setShow(false)}
      >
        <Tooltip className='bannerScheduleLinks'>
          {calendars.map((dataCalendar) => {
            if (dataCalendar.url) {
              return (
                <a
                  key={dataCalendar.title}
                  className='scheduleItem'
                  href={getUrlCalendar(content, dataCalendar.url)}
                  target='_blank'
                  onClick={(e) => e.stopPropagation()}
                >
                  {dataCalendar.title}
                </a>
              );
            }

            return (
              <a
                key={dataCalendar.title}
                className='scheduleItem'
                href='#'
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  dataCalendar.fn(content);
                }}
              >
                {dataCalendar.title}
              </a>
            );
          })}
        </Tooltip>
      </Overlay>
    </>
  );
};

export default SchedulePopover;
